import { yupResolver } from '@hookform/resolvers/yup'
import { rules, schema } from '@config/yup.schema'

const hookFormConfig = {
  defaultValues: {
    name: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: '',
    address: '',
    price: '',
    provider: '',
    district: null,
    customer_type_id: '',
    referral_code: '',
  },
  resolver: yupResolver(schema({
    name: rules.stringRequired,
    email: rules.email,
    phone: rules.phoneNumber,
    password: rules.passwordOptional,
    password_confirmation: rules.passwordOptional,
    address: rules.stringRequired,
    customer_type_id: rules.stringRequired,
    district: rules.mixed,
    payment_method: rules.paymentMethod2,
  })),
}

export default hookFormConfig
